import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * Single source of truth for whether the Interview Guides feature is on.
 *
 * Used by the routes (App.tsx), the nav links (AdminNav), and the per-page
 * guards so all three gate consistently.
 */
export function useInterviewGuidesEnabled(): boolean {
  const { interviewGuides } = useFlags();
  // Return LD's own value — the flag's default is configured in LaunchDarkly,
  // so we read it rather than imposing a default here.
  return interviewGuides;
}
